import { defineComponent, useSlots, ref, computed, openBlock, createElementBlock, normalizeClass, createVNode, createCommentVNode, renderSlot } from "vue";
import Loader from "./Loader.vue.es.js";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
  key: 0,
  class: "icon loading-icon"
};
const _hoisted_3 = {
  key: 1,
  class: "icon"
};
const _hoisted_4 = {
  key: 2,
  class: "btn-content"
};
const _hoisted_5 = {
  key: 3,
  class: "icon right-icon"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    type: { default: "primary" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    inactive: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    textWrap: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const slots = useSlots();
    const uiKitBtn = ref();
    const hasText = computed(() => !!slots.default);
    const hasIcon = computed(() => !!slots.icon);
    const onlyIcon = computed(() => hasIcon.value && !hasText.value);
    const hasRightIcon = computed(() => !!slots["right-icon"]);
    const buttonClasses = computed(() => {
      return {
        [`uikit-btn-${props.type}`]: true,
        "uikit-btn-loading": props.loading,
        "uikit-btn-only-icon": onlyIcon.value,
        "uikit-btn-inactive": props.inactive,
        "uikit-btn-active": props.active,
        "uikit-btn-text-wrap": props.textWrap
      };
    });
    const handleClick = () => {
      var _a;
      (_a = uiKitBtn.value) == null ? void 0 : _a.blur();
      if (props.disabled || props.inactive) {
        return;
      }
      emit("click");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        ref_key: "uiKitBtn",
        ref: uiKitBtn,
        class: normalizeClass(["uikit-btn", buttonClasses.value]),
        disabled: _ctx.disabled,
        type: "button",
        onClick: handleClick
      }, [
        _ctx.loading ? (openBlock(), createElementBlock("span", _hoisted_2, [
          createVNode(Loader, {
            show: true,
            transparent: true,
            width: "100%",
            height: "100%"
          })
        ])) : createCommentVNode("", true),
        hasIcon.value && !_ctx.loading ? (openBlock(), createElementBlock("span", _hoisted_3, [
          renderSlot(_ctx.$slots, "icon", {}, void 0, true)
        ])) : createCommentVNode("", true),
        hasText.value ? (openBlock(), createElementBlock("span", _hoisted_4, [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ])) : createCommentVNode("", true),
        hasRightIcon.value ? (openBlock(), createElementBlock("span", _hoisted_5, [
          renderSlot(_ctx.$slots, "right-icon", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ], 10, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Button.vue.es2.js.map
